export const LOAD = 'community/PROPOSITION_PAGE_LOAD';

export const FETCH_PROPOSITION_SUCCESS = 'community/PROPOSITION_PAGE_FETCH_PROPOSITION_SUCCESS';
export const FETCH_PROPOSITION_FAILURE = 'community/PROPOSITION_PAGE_FETCH_PROPOSITION_FAILURE';
